const FRONTEND_CONFIG = {
  API_URL: "https://ld.eduxerp.com",

  // Exam Time Window (LOCAL time)
  EXAM_START: "2025/12/12 13:33:00",
  EXAM_END:   "2025/12/12 13:35:00",  // 1 hour window (adjust if needed)

  EXAM_DURATION_MINUTES: 60,  // 60 minutes
};

export default FRONTEND_CONFIG;
